import React, { useContext } from 'react';
import styled from 'styled-components';
import { CartContext } from './contexts/CartContext';
import CartItem from './CartItem';


import {
  SwipeableList,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';

const CartProducts = () => {

    const { cartItems, removeProduct } = useContext(CartContext);

    const trailingActions = (product) => (
      <TrailingActions>
        <SwipeAction
          destructive={true}
          onClick={() => removeProduct(product)}
        >
          <DeleteAction>
            Delete
          </DeleteAction>
        </SwipeAction>
      </TrailingActions>
    );

    return (
        <ItemsCard>
            <SwipeableList>
                {cartItems.map(product => (
                    <SwipeableListItem
                        key={product.id}
                        trailingActions={trailingActions(product)}
                    >
                        <CartItemWrapper>
                            <CartItem product={product} />
                        </CartItemWrapper>
                    </SwipeableListItem>
                ))}
            </SwipeableList>
        </ItemsCard>
    );
}

export default CartProducts;

const ItemsCard = styled.div`
  background: #fff;
  border: 1px solid rgba(31, 45, 61, 0.08);
  border-radius: 16px;
  overflow: hidden;
  padding: 4px 12px;

  @media screen and (min-width: 480px) {
    padding: 6px 18px;
  }
`;

const CartItemWrapper = styled.div`
  width: 100%;
`;

const DeleteAction = styled.div`
  background-color: #ef5350;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  font-weight: 700;
  font-size: var(--text-sm);
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(31, 45, 61, 0.08);
`;
